export default __webpack_public_path__ + "83cb00485283d639bf734de878d208b8.svg";